import { createFileRoute, redirect } from "@tanstack/react-router";

import { MorrowContextPanel } from "../components/context/MorrowContextPanel";
import { useI18n } from "../i18n";

export const Route = createFileRoute("/dev/context-panel")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/", replace: true });
    }
  },
  component: DevContextPanelRoute,
});

function DevContextPanelRoute() {
  const { t } = useI18n();

  return (
    <div className="flex h-dvh min-h-0 flex-col bg-background">
      <header className="shrink-0 border-b border-border/60 px-4 py-3">
        <h1 className="text-sm font-medium">{t("contextPanel.stagingTitle")}</h1>
        <p className="mt-1 text-xs text-muted-foreground">{t("contextPanel.stagingHint")}</p>
      </header>
      <div className="min-h-0 flex-1">
        <MorrowContextPanel />
      </div>
    </div>
  );
}
